import React, { Component } from 'react';
import i18n from 'i18n-react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default class HomeButton extends Component {
  static contextTypes = {
    router: () => true,
  }
  
  render() {
    const { history } = this.context.router;
    return (
      <button
        className="homeButton"
        onClick={ () => history.push('/main')}
        >
        
        <FontAwesomeIcon icon={['far', 'home']} />
      </button>
    )
  }
};
